import { createPrivacyRegion } from "./IPrivacyRegion.js";
export const CcpaRegions = [
  createPrivacyRegion("CCPA", { code: "US", name: "United States" }, { code: "CA", name: "California" }),
] as const;
export type CcpaRegions = typeof CcpaRegions[ number ];

Object.freeze(CcpaRegions);


// export const CcpaRegions = [
//   createPrivacyRegion("CCPA", { code: "US", name: "United States" }, { code: "CA", name: "California" }),
// ] as const;
// export type CcpaRegions = typeof CcpaRegions[ number ];

// Object.freeze(CcpaRegions);